import {
  LoaderErrors
} from '../io/loader';
import DemuxErrors from '../demux/demux-errors';

/*
 * Copyright (C) 2016 Bilibili. All Rights Reserved.
 *
 * @author zheng qian <xqq@xqq.im>
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const ErrorTypes = {
  NETWORK_ERROR: 'NetworkError',
  MEDIA_ERROR: 'MediaError',
  OTHER_ERROR: 'OtherError'
};

export const ErrorDetails = {
  NETWORK_EXCEPTION: LoaderErrors.EXCEPTION,
  NETWORK_STATUS_CODE_INVALID: LoaderErrors.HTTP_STATUS_CODE_INVALID,
  NETWORK_TIMEOUT: LoaderErrors.CONNECTING_TIMEOUT,
  NETWORK_UNRECOVERABLE_EARLY_EOF: LoaderErrors.UNRECOVERABLE_EARLY_EOF,

  MEDIA_MSE_ERROR: 'MediaMSEError',

  MEDIA_FORMAT_ERROR: DemuxErrors.FORMAT_ERROR,
  MEDIA_FORMAT_UNSUPPORTED: DemuxErrors.FORMAT_UNSUPPORTED,
  MEDIA_CODEC_UNSUPPORTED: DemuxErrors.CODEC_UNSUPPORTED
};